import { createAsyncThunk } from '@reduxjs/toolkit'

import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'
import taThemesAPI from 'api/ApiActions/TextAnalysis/Themes'
import { handleStatus500 } from 'api/Utility/HandleStatus500'

const searchParams = new URLSearchParams(window.location.search)
const ownerId = searchParams.get('owner_id')
const ownerType = searchParams.get('owner_type')
const path = window.location.pathname.split('/')
const projectId = searchParams.get('project_id') || path[path.length - 1]

// Extract new Themes
export const postThemes: any = createAsyncThunk<
  any,
  any,
  { dispatch: AppDispatch; state: RootState }
>('textAnalysis/postThemes', async (req = {}, { rejectWithValue }) => {
  const obj = {
    ...req,
    associations: {
      project: { id: projectId, type: 'Project' },
      owner: { id: ownerId, type: ownerType },
    },
  }

  const res = await taThemesAPI.postThemes(obj)

  if (res?.status >= 200 && res?.status < 300) {
    return res.data
  }

  handleStatus500(res, '', 'TA')
  return rejectWithValue('Error occurred')
})

// Fetch current Themes
export const getThemes: any = createAsyncThunk<
  any,
  any,
  { dispatch: AppDispatch; state: RootState }
>('textAnalysis/getThemes', async (req = {}, { rejectWithValue }) => {
  const obj = {
    ...req,
    attributes: {
      'project.id': projectId,
      'owner.id': ownerId,
      'owner.type': ownerType,
    },
  }

  const res = await taThemesAPI.getThemes(obj)

  if (res?.status >= 200 && res?.status < 300) {
    return res.data
  }

  handleStatus500(res, '', 'TA')
  return rejectWithValue('Error occurred')
})

// Update the key phrases in a theme
export const updatePhrases: any = createAsyncThunk<
  any,
  any,
  { dispatch: AppDispatch; state: RootState }
>('textAnalysis/updateKeyPhrases', async (req = {}, { rejectWithValue }) => {
  const res = await taThemesAPI.updateThemes(req)

  if (res?.status >= 200 && res?.status < 300) {
    return res.data
  }

  handleStatus500(res, '', 'TA')
  return rejectWithValue('Error occurred')
})

// Fetch all key phrases
export const getAllKeyPhrases: any = createAsyncThunk<
  any,
  any,
  { dispatch: AppDispatch; state: RootState }
>('textAnalysis/getAllKeyPhrases', async (req = {}, { rejectWithValue }) => {
  const obj = {
    attributes: {
      'project.id': projectId,
      'project.type': 'Project',
      'owner.id': ownerId,
      'owner.type': ownerType,
    },
    search: req?.search || null,
  }

  const res = await taThemesAPI.getAllPhrases(obj)

  if (res?.status >= 200 && res?.status < 300) {
    return res.data
  }

  handleStatus500(res, '', 'TA')
  return rejectWithValue('Error occurred')
})

// Delete a theme
export const deleteTheme: any = createAsyncThunk<
  any,
  any,
  { dispatch: AppDispatch; state: RootState }
>('textAnalysis/deleteTheme', async (req = {}, { rejectWithValue }) => {
  const res = await taThemesAPI.deleteTheme({
    themeId: req.themeId,
  })

  if (res?.status >= 200 && res?.status < 300) {
    return res.data
  }

  handleStatus500(res, '', 'TA')
  return rejectWithValue('Error occurred')
})
